import React from "react";
import { useTranslation } from "react-i18next";
import { roundTo, UnitEquivalentItem } from "@helpers/utils";

type UnitEquivalentsBadgesProps = {
    baseQuantity?: number | null;
    baseUnitLabel?: string | null;
    unitEquivalents?: UnitEquivalentItem[];
    placeholder?: string;
};

export default function UnitEquivalentsBadges({
    baseQuantity,
    baseUnitLabel,
    unitEquivalents,
    placeholder = "0",
}: UnitEquivalentsBadgesProps) {
    const { t } = useTranslation("", { keyPrefix: "products.general" });

    if (!unitEquivalents || unitEquivalents.length === 0) {
        return <div className="text-accent">{placeholder}</div>;
    }

    const formatValue = (value: number) => {
        if (!Number.isFinite(value)) {
            return placeholder;
        }

        return String(roundTo(value, 2));
    };

    const baseLabel = baseUnitLabel ? ` ${baseUnitLabel}` : "";

    return (
        <div className="flex flex-wrap gap-2">
            {unitEquivalents.map((item, index) => {
                const unitLabel = item.unit.code || item.unit.name;
                const equivalentValue = item.quantity ? 1 / item.quantity : 0;
                const stockValue =
                    item.quantity && baseQuantity ? baseQuantity / item.quantity : 0;

                return (
                    <div
                        key={`${item.unit.id}-${index}`}
                        className="text-xs text-accent bg-[#F4F4F4] px-1.5 py-0.5 rounded"
                    >
                        {`1${baseLabel} = ${formatValue(equivalentValue)} ${unitLabel} | `}
                        {`${t("unitEquivalents.inStockLabel")}: ${formatValue(
                            stockValue
                        )} ${unitLabel}`}
                    </div>
                );
            })}
        </div>
    );
}
